var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLogIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.767,
    height: 17.767,
    viewBox: "0 0 17.767 17.767",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-log-in",
    "data-name": "Icon feather-log-in",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_30481",
    "data-name": "Pfad 30481",
    d: "M22.5,4.5H26a1.752,1.752,0,0,1,1.752,1.752V18.515A1.752,1.752,0,0,1,26,20.267H22.5",
    transform: "translate(-11.989 -4.5)",
    fill: "none",
    stroke: "#1c9d87",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_30482",
    "data-name": "Pfad 30482",
    d: "M15,19.259l4.38-4.38L15,10.5",
    transform: "translate(-8.868 -6.996)",
    fill: "none",
    stroke: "#1c9d87",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_30483",
    "data-name": "Pfad 30483",
    d: "M15.011,18H4.5",
    transform: "translate(-4.5 -10.117)",
    fill: "none",
    stroke: "#1c9d87",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogIn);
export default __webpack_public_path__ + "static/media/Icon-Log-in.4e52937311534885e72e8526ffed3bb8.svg";
export { ForwardRef as ReactComponent };